exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-305fee9c] .el-input__inner,[data-v-305fee9c] .el-textarea__inner {\n  border: none;\n  border-radius: 0;\n  resize: none;\n  padding-left: 0;\n  padding-right: 0;\n  border-bottom: 1px solid #d9d9d9;\n}\n", ""]);

// exports
